import React from 'react';
import { motion } from 'framer-motion';
interface CTAButtonProps {
  children: React.ReactNode;
  href?: string;
  onClick?: () => void;
  variant?: 'primary' | 'secondary';
  className?: string;
}
export function CTAButton({
  children,
  href = '#checkout',
  onClick,
  variant = 'primary',
  className = ''
}: CTAButtonProps) {
  const baseClasses = 'inline-block px-8 py-5 text-lg font-bold rounded-lg shadow-lg transition-all duration-300 text-center w-full sm:w-auto';
  const variantClasses = variant === 'primary' ? 'bg-gradient-to-r from-amber-500 to-amber-600 text-white hover:from-amber-600 hover:to-amber-700 hover:shadow-xl' : 'bg-teal-700 text-white hover:bg-teal-800 hover:shadow-xl';
  return <motion.a href={href} onClick={onClick} className={`${baseClasses} ${variantClasses} ${className}`} whileHover={{
    scale: 1.02
  }} whileTap={{
    scale: 0.98
  }} data-id="element-92">
      {children}
    </motion.a>;
}